import React, { Component } from 'react';
import './redeem.scss';

import Loading from '../../common/loading/loading';
import { ImageConstants } from '../../../constants/constants';
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component';
import { getImageSource } from '../../../utility/image-source'
import { Modal, ModalBody, } from "reactstrap";
import RewardApi from '../../../apis/rewards'

import CWConfirm from '../../common/cw-confirmation-modal/cw-confirmation-modal'
import Store from '../../../store/store';
import CommonUtils from '../../../utility/common-utilities';

class Rewards extends Component {
    state = {
        loading: false,
        availablePoints: this.props.reward?.availablePoints || 0,
        moneyEarned: this.props.reward?.amount || 0,
        vouchers: []
    }

    componentDidMount() {
        this.getVouchers()
    }

    getVouchers(payload = {}) {
        this.setState({ isLoading: true })
        RewardApi.getVouchers(payload)
            .then(response => {
                let vouchers = response?.response || []
                this.setState({ vouchers, isLoading: false })
            }).catch(err => {
                this.setState({ isLoading: false })
            })
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 3000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }

    onClickInfo = () => {

        this.setState({ showRedeemInfo: !this.state.showRedeemInfo })
    }

    onSelectCard(item) {
        if (this.state.availablePoints < item.point) return
        this.setState({ selectedVoucher: item._id, selectedVoucherInfo: item })
    }

    getImage(item) {
        if (this.state.availablePoints < item.point) return getImageSource(ImageConstants.ELLIPSE_INACTIVE)

        if (this.state.selectedVoucher === item._id) return getImageSource(ImageConstants.ELLIPSE_ACTIVE)

        return getImageSource(ImageConstants.ELLIPSE)
    }

    getCardColors(index) {
        let colors = ["grad-blue", "grad-red", "grad-yellow", "grad-green", "grad-orange"]

        if (index < 4) return colors[index]

        let value = index % 5

        return colors[value]

    }

    redeemPoints = (id) => {
        let voucher = id || this.state.redeemVoucher
        if (!voucher) return

        let payload = {
            voucherId: voucher
        }
        this.setState({ isLoading: true })
        RewardApi.purchaseVoucher(payload)
            .then(response => {

                let availablePoints = this.state.availablePoints
                let moneyEarned = this.state.moneyEarned

                availablePoints -= response?.data?.point || 0
                moneyEarned -= response?.data?.price || 0

                this.setState({ isLoading: false, selectedVoucherInfo: null, selectedVoucher: "", availablePoints, moneyEarned, forceRefetch: true })
                this.hideVoucherInfo()
                this.hideConfirmModal()
                let store = Store.getStore("headerComponent")
                store.getReward && store.getReward()
                this.showToaster("success", "Voucher purchased successfully - We will get back to you within 24hrs")
            }).catch(err => {
                this.showToaster("success", "Something went wrong")
                this.setState({ isLoading: false })
            })
    }

    onClickRedeem(voucher) {
        if (!this.state.selectedVoucher) return
        this.setState({ redeemVoucher: voucher, showConfirmModal: true, message: "Go ahead and purchase this voucher??" })
    }

    hideConfirmModal = () => {
        this.setState({ redeemVoucher: null, showConfirmModal: false })
    }

    showVoucherInfo(e, item) {

        if (!item) return
        this.setState({ showVoucherInfo: true, voucherInfo: item })
    }

    hideVoucherInfo = () => {
        this.setState({ showVoucherInfo: false, voucherInfo: null })
    }

    renderVoucherCards() {
        return (
            <div className="">
                <div className="row">
                    {
                        this.state.vouchers?.length ?
                            this.state.vouchers?.map((item, index) => (

                                <div className="col-lg-6 col-md-6 col-sm-12 mt-4" onClick={() => this.onSelectCard(item)}>
                                    <div className={`cw-card voucher-card ${this.getCardColors(index)}`}>
                                        <div className="image-wrapper">
                                            <img alt="" className="image" src={item.image} />
                                        </div>
                                        <div className="detail-wrapper">
                                            <img className="radio-button" alt="" src={this.getImage(item)} />
                                            <div className="title ">{item.title}</div>
                                            {/* <div className="description">{item.shortDescription}</div> */}
                                            <div className="description">Worth {item.currency?.symbol} {item.price}</div>
                                            <div className="pt-4"><span className="avail mr-2">Redeem </span><span className="point">{item.point} </span> points to get this voucher</div>
                                            <img alt="" className="info-image" src={getImageSource(ImageConstants.INFO)} onClick={(e) => this.showVoucherInfo(e, item)} />
                                        </div>
                                    </div>
                                </div>
                            ))
                            :
                            <div className="col pt-4 text-center">No Records found</div>
                    }
                </div>

            </div>
        )
    }

    renderVoucherDetail() {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.hideVoucherInfo} size={'lg'}>
                <ModalBody >
                    <div className="redeem">
                        <div className="row">
                            <div className="col text-right my-auto"><img alt="" className='close-icon cursor-pointer' src={getImageSource(ImageConstants.CROSS)} onClick={this.hideVoucherInfo} /></div>
                        </div>
                        <div className="p-4">
                            <div className="header-text text-center">Are you sure you want to get this Voucher?</div>
                            <div className="p-4">
                                <div className="row">
                                    <div className="col mt-4" >
                                        <div className={`cw-card voucher-card ${this.getCardColors(1)}`}>
                                            <div className="image-wrapper">
                                                <img alt="" className="image" src={this.state.voucherInfo?.image} />
                                            </div>
                                            <div className="detail-wrapper">
                                                <div className="title ">{this.state.voucherInfo?.title}</div>
                                                <div className="description">Worth {this.state.voucherInfo.currency?.symbol} {this.state.voucherInfo.price}</div>
                                                <div className="pt-4"><span className="avail mr-2">Redeem </span><span className="point">{this.state.voucherInfo?.point} </span> points to get this voucher </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="pt-4">
                                <div className="long-description">{this.state.voucherInfo?.description}</div>
                            </div>
                        </div>

                        <div className="text-center py-4">
                            <button className={`cw-btn-md mr-2 cw-button-disabled`} onClick={this.hideVoucherInfo} >
                                CANCEL
                            </button>
                            {
                                this.state.availablePoints >= this.state.voucherInfo?.point ?
                                    <button className={`cw-btn-md cw-btn-blue`} onClick={() => this.redeemPoints(this.state.voucherInfo?._id)} >
                                        REDEEM POINTS
                                    </button> : ""
                            }
                        </div>
                    </div>

                </ModalBody>
            </Modal>
        )
    }

    render() {
        return (
            <div className="redeem">
                {this.state.loading && <Loading />}

                <div className="pt-4">
                    <div ><img className='back-icon cursor-pointer' alt="" src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.props.back(this.state.forceRefetch)} /></div>

                    <div className="row pt-4">
                        <div className="col">
                            <span className='screen-title'>Redeem Points</span>
                            <div>You can redeem your reward points for the following coupons. The value of the coupons is based on the Points Earned. </div>
                        </div>
                        <div className="col text-right">
                            <button className={`cw-btn-md ${this.state.selectedVoucher ? " cw-btn-primary" : "cw-button-disabled"}`} onClick={(e) => this.showVoucherInfo(e, this.state.selectedVoucherInfo)} >
                                REDEEM POINTS
                            </button>
                        </div>
                    </div>

                    <div className="pt-4">
                        <div className="cw-card point-card grad-purble d-inline-block mr-2">
                            <div className="point text-center mr-2">{CommonUtils.convertToFixed(this.state.availablePoints, 2)}</div>
                            <div className="point-title text-center">REWARD POINTS AVAILABLE</div>
                        </div>

                        {/* <div className="cw-card point-card grad-yellow d-inline-block">
                            <div className="point text-center mr-2">{CommonUtils.convertToFixed(this.state.moneyEarned, 2)}</div>
                            <div className="point-title text-center">MONEY EARNED</div>
                        </div> */}
                    </div>


                    <div className="pt-4">{this.renderVoucherCards()}</div>

                </div>

                {
                    this.state.showVoucherInfo ? this.renderVoucherDetail() : ""
                }

                {this.state.showToaster ? <ToasterComponent message={this.state.toasterMessage} type={this.state.toasterType} /> : ""}
                {this.state.showConfirmModal && <CWConfirm modal={this.state.showConfirmModal} close={this.hideConfirmModal} message={this.state.message} onOk={this.redeemPoints.bind(this)} />}
            </div>);
    }
}

export default Rewards;